import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { RouteComponentProps } from 'react-router';
import { CalculatorResultsPageProps } from '../models';
import { calculateCompetitionMonthlyPrices } from '../utils';
import BREAK_POINTS from '../../../styling/media-queries';
import { CallToAction } from '../../../styling/styles';
import CalculatorResultsOverview from './components/CalculatorResultsOverview';
import CalculatorResultsTable from './components/CalculatorResultsTable';
import Disclaimer from '../../../components/Disclaimer';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../assets';
import { ctaProps } from '../../../constants';
import { useDevicesFromQueryString } from 'packages/smart-home-support/hooks';
import { getPartner, PartnerContent } from 'packages/smart-home-support/partner';

const CalculatorResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 15px;
  @media ${BREAK_POINTS.mobileBig} {
    margin: 0 20px;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 20px;
  margin-bottom: 40px;

  @media ${BREAK_POINTS.desktop} {
    margin-bottom: 80px;
  }
`;

const HeroButton = styled(Link)`
  ${CallToAction}
  font-weight: 600;
  margin-top: 10px;
  background-color: ${(props) => (props.inverted ? '#fff' : props.theme.colors.primaryAccent)};
  text-transform: ${(props) => props.theme.styles.callToActionTextTransform};
`;

const InnerContainer = styled.div``;

const CalculatorResultsPage: React.FunctionComponent<CalculatorResultsPageProps & RouteComponentProps> = (props) => {
  const { competitors, devices, location } = props;

  const selectedDevices = useDevicesFromQueryString(location, devices);

  const competitionMonthlyPrices = calculateCompetitionMonthlyPrices(competitors, devices, selectedDevices);

  return (
    <div>
      <CalculatorResultsContainer>
        <InnerContainer>
          <CalculatorResultsOverview />
          <CalculatorResultsTable competitionMonthlyPrices={competitionMonthlyPrices} />
          <Disclaimer footnoteNumber={2}>{getPartnerAsset(DynamicAssetsKeys.calculatorDisclaimer2)}</Disclaimer>
        </InnerContainer>
      </CalculatorResultsContainer>
      <ButtonContainer>
        <PartnerContent TechCoachHome="" Verizon="">
          <HeroButton {...ctaProps}>Join {getPartner().productName}</HeroButton>
        </PartnerContent>
      </ButtonContainer>
    </div>
  );
};

export default CalculatorResultsPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/results/index.tsx